<section class="p-3">
  <h3 class="title mb-4 d-flex align-items-center gap-2">
    <img
      src="assets/img/logo_recibo_verde_sv_solo.svg"
      alt=""
      class="recibo-verde-title-icon"
      width="28"
      height="26"
    />
    ReciboVerde
  </h3>
  <article class="recibo-verde-content px-3">
    <div
      class="status-card content-block-wide mb-3"
      [class.status-card--promo]="statusCardMode() === 'inactive'"
      [class.status-card--active]="statusCardMode() === 'active'"
      [class.status-card--mailbox]="statusCardMode() === 'activeWithMailbox'"
    >
      <div class="status-card-body">
        <div class="status-card-icon" aria-hidden="true">
          @switch (statusCardMode()) {
            @case ('inactive') {
              <img
                src="assets/img/logo_recibo_verde_sv_solo.svg"
                alt=""
                class="status-card-logo"
                width="32"
                height="30"
              />
            }
            @case ('active') {
              <i class="pi pi-envelope"></i>
            }
            @case ('activeWithMailbox') {
              <i class="pi pi-inbox"></i>
            }
          }
        </div>

        <div class="status-card-content">
          @switch (statusCardMode()) {
            @case ('inactive') {
              <p class="status-card-text mb-0">
                Activa el ReciboVerde y recibe tus liquidaciones por email y reduce el uso de papel.
              </p>
            }
            @case ('active') {
              <p class="status-card-text mb-0">
                Ya recibes tus liquidaciones por email y contribuyes a conservar el medio ambiente
                reduciendo el uso de papel.
              </p>
            }
            @case ('activeWithMailbox') {
              <p class="status-card-text mb-0">
                Actualmente recibes tus liquidaciones por email y en papel. Desactiva el envío en
                papel para recibirlas solo por email y ayudar a reducir el consumo de papel.
              </p>
            }
          }

          @if (statusCardMode() === 'active' || statusCardMode() === 'activeWithMailbox') {
            <div class="status-card-actions">
              @if (statusCardMode() === 'activeWithMailbox') {
                <p-button
                  label="Desactivar envío en papel"
                  icon="pi pi-inbox"
                  severity="success"
                  size="small"
                  (onClick)="openMailboxDeactivateDialog()"
                />
              }
              <button type="button" class="deactivate-link" (click)="openDeactivateDialog()">
                @if (statusCardMode() === 'activeWithMailbox') {
                  Desactivar envío por email
                } @else {
                  Desactivar
                }
              </button>
            </div>
          }
        </div>
      </div>
    </div>

    <p-card class="content-block" header="Destinatarios">
      <p-inputgroup>
        <p-floatlabel variant="in">
          <input pInputText id="email" [formControl]="emailCtrl" />
          <label for="email">Añadir correo electrónico</label>
        </p-floatlabel>
        <p-inputgroup-addon>
          <p-button class="ms-auto h-100" icon="pi pi-plus-circle" (onClick)="addMail()" />
        </p-inputgroup-addon>
      </p-inputgroup>
      <div class="destinatarios-table-wrapper">
        <p-table [value]="$settings.settlementEmails()" [tableStyle]="{ 'min-width': '32rem' }">
          <ng-template #header>
            <tr>
              <th>Correo electrónico</th>
              <th></th>
            </tr>
          </ng-template>
          <ng-template #body let-mail>
            <tr>
              <td>{{ mail }}</td>
              <td width="0.5rem" class="pe-0">
                @if ($settings.settlementEmails().length > 1) {
                  <p-button
                    outlined
                    severity="danger"
                    class="ms-auto h-100"
                    icon="pi pi-times-circle"
                    (onClick)="deleteMail(mail)"
                  />
                }
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>

      <div class="destinatarios-actions d-flex justify-content-end gap-2 mt-4 flex-wrap">
        @if (isActive) {
          <p-button
            class="ms-auto"
            label="Guardar cambios"
            icon="pi pi-send"
            (onClick)="submit()"
          />
        } @else {
          <p-button class="activate-recibo-verde-btn ms-auto" (onClick)="submit()">
            <ng-template #content>
              <span class="activate-recibo-verde-btn-content">
                Activar
                <span class="recibo-verde-btn-icon" aria-hidden="true"></span>
                ReciboVerde
              </span>
            </ng-template>
          </p-button>
        }
      </div>
    </p-card>
  </article>
</section>

<p-dialog
  header="Desactivar ReciboVerde"
  [(visible)]="showDeactivateDialog"
  [modal]="true"
  [style]="{ width: '32rem' }"
>
  <p>
    El envío de las liquidaciones por email reduce el uso innecesario del papel. ¿Seguro que quieres
    desactivar ReciboVerde?
  </p>
  <ng-template #footer>
    <p-button label="Cancelar" severity="secondary" (onClick)="showDeactivateDialog = false" />
    <p-button label="Desactivar" severity="danger" (onClick)="confirmDeactivate()" />
  </ng-template>
</p-dialog>

<p-dialog
  header="Envío en papel activado"
  [(visible)]="showMailboxOnActivateDialog"
  [modal]="true"
  [style]="{ width: '32rem' }"
>
  <p>
    Has activado ReciboVerde para recibir tus liquidaciones por email. ¿Quieres dejar de recibirlas
    también en papel?
  </p>
  <ng-template #footer>
    <p-button
      label="Mantener envío en papel"
      severity="secondary"
      (onClick)="confirmActivateWithMailboxChoice(false)"
    />
    <p-button
      label="Sí, dejar de recibir en papel"
      (onClick)="confirmActivateWithMailboxChoice(true)"
    />
  </ng-template>
</p-dialog>

<p-dialog
  header="Desactivar buzoneo"
  [(visible)]="showMailboxDeactivateDialog"
  [modal]="true"
  [style]="{ width: '32rem' }"
>
  <p>
    Dejar de recibir liquidaciones en papel contribuye a cuidar el medio ambiente. ¿Desactivar el
    buzoneo?
  </p>
  <ng-template #footer>
    <p-button
      label="Cancelar"
      severity="secondary"
      (onClick)="showMailboxDeactivateDialog = false"
    />
    <p-button
      label="Desactivar buzoneo"
      icon="pi pi-inbox"
      severity="success"
      (onClick)="confirmMailboxDeactivate()"
    />
  </ng-template>
</p-dialog>
